module.exports = __webpack_public_path__ + "static/fonts/Nexa_Bold.56018b3.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Nexa/Nexa_Bold.otf
// module id = mjlg
// module chunks = 3